import React, { useEffect, useMemo, useRef } from "react";
import classNames from "classnames";
import { Viewer } from "photo-sphere-viewer";
import "photo-sphere-viewer/dist/photo-sphere-viewer.css";
import "./style.scss";
let _viewer;
const CarInteriorViewer = ({ interiorModels, models, modelIndex, interiorIndex, onModelChange = () => false, onInteriorChange = () => false, viewerName = '' }) => {
  const viewerNode = useRef(null);
  const model = useMemo(() => models[modelIndex], [models, modelIndex]);
  const currentInterior = useMemo(() =>interiorModels ? interiorModels[interiorIndex] : null,[interiorModels, interiorIndex]);
  const destroyViewer = () => {
    if (_viewer) {
      _viewer.destroy();
      _viewer = null;
    }
  };

  // Preload Image
  const preloadImage = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;
      img.onload = resolve;
      img.onerror = resolve; 
    });
  };
  useEffect(() => {
    destroyViewer();
    if (viewerNode.current) {
      const imgUrl = viewerName === 'Car360ViewV2' ? currentInterior?.fields.Image.value.src : model?.fields.interiorImage.value.src;

      preloadImage(imgUrl).then(() => {
        _viewer = new Viewer({
          container: viewerNode.current,
          panorama: imgUrl,
        });
      });
    }
    return () => {
      destroyViewer();
    };
  }, [interiorIndex, currentInterior,modelIndex, viewerName]);

  return (
    <div className="s-car-interior-viewer">
      <div ref={viewerNode} className="s-car-interior-viewer__box" />
      {/*<div className="s-car-interior-viewer__models">*/}
      {/*  {models.map((model, i) => (*/}
      {/*    <div className={classNames("s-car-interior-viewer__model", { active: i === modelIndex })} style={{ backgroundImage: `url(${model.fields.interiorThumb.value.src})`, borderColor: model.fields.color.fields.phrase.value }} key={i} onClick={e => onModelChange(e, i)} />*/}
      {/*  ))}*/}
      {/*</div>*/}
      {viewerName === 'Car360ViewV2' &&
        <div className="c-car360-view-v2__color">
          {
            interiorModels && interiorModels.map((interior, index) => {
              const { switcherColorLeft, switcherColorRight, switcherColorText } = interior.fields;
              const isActive = index === interiorIndex;
              return (
                <div key={interior.id} className="color-container interior">
                  {isActive && <div className="color-line" ></div>}
                  <div className={`btn ${isActive ? 'active' : ''}`} onClick={(e) => onInteriorChange(e, index)} >
                    <div className="outer-circle" style={{ border: isActive ? `1px solid ${switcherColorLeft?.value.slice(0, 7)}` : 'none' }}></div>
                    <div className="inner-circle" style={{ background: `linear-gradient(144.29deg, ${switcherColorLeft?.value}, ${switcherColorRight?.value})` }}></div>
                  </div>
                  <div className={`color-name ${isActive ? 'fade' : ''} ${index === 0 ? 'active' : ''}`} >{switcherColorText?.value}</div>
                </div>
              )
            })
          }
        </div>
      }
    </div>
  );
};
export default CarInteriorViewer;
